import React from 'react';

import PropTypes from "prop-types";
export default function Rate({ currentRate }) {
  let arrOfStar = [];
  for (let i = 0; i < 5; i++) {
    if (i >= currentRate) {
      arrOfStar.push(<i key={i} className="fa fa-star"></i>);
    } else {
      arrOfStar.push(<i key={i} className="fa fa-star"></i>);
    }
  }
  return <div className="rate">{arrOfStar}</div>;
}

Rate.propTypes = {
  currentRate: PropTypes.number,
};
